<div class="page-wrapper">
    <div class="d-flex gap-2 align-items-center mb-3">
        <button (click)="goBack()" class="btn-white">
            <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.67969 3.1737H1.41258L3.55632 5.07945L3.09831 5.48945L0.165782 2.8853L3.09831 0.27832L3.55632 0.688311L1.41258 2.59406H6.67969V3.1737Z"
                    fill="#052B63" />
            </svg>
            Back
        </button>
        <h4 class="page-title ">TAXPER DETAILS</h4>
    </div>


    <div class="page-content-wrapper">
        @if(this.details) {
        <div class="form-wrapper ">

            <div class="content">


                <div class="details">
                    <div class="left d-flex flex-column gap-3">
                        <h6 class="text-decoration-underline fw-bold mb-1">ASSET DETAILS </h6>
                        <span class="fw-bold" style="font-size: 18px; text-transform: uppercase;"
                            *ngIf="initialData?.displayName">{{initialData?.displayName}}</span>
                        <div><strong class="fw-bold">Property ID: </strong> {{ this.details?.pid }}</div>
                        <div><strong class="fw-bold">Type: </strong> {{ this.details?.type }}</div>
                        <div><strong class="fw-bold">Category: </strong> {{ this.details?.category }}</div>
                        <div><strong class="fw-bold">Full Address: </strong> {{ this.details?.address }}</div>
                        <div><strong class="fw-bold">GIS Coordinate: </strong>{{ '(' + details.longitude + ', ' +
                            details.latitude + ')' }} </div>
                        <div><strong class="fw-bold">Date Created: </strong> {{ this.details?.createdAt | date }}</div>
                    </div>
                </div>



                <div class="details">
                    <div class="left d-flex flex-column gap-3"
                        style="border-top: 1px solid #e0e0e0; padding-top: 20px; margin-top: 20px;">
                        <h6 class="text-decoration-underline fw-bold mb-1">OCCUPANTS </h6>

                        <!-- <div><strong class="fw-bold">Number of Flats: </strong> {{ this.details?.asin }}</div> -->
                        <div><strong class="fw-bold">Number of Occupants: </strong> {{ this.details?.numberOfOccupants
                            }}</div>
                    </div>

                    <table class="custom-table mt-2 table-bordered" style="max-width: 300px; margin-top: 10px;">
                        <thead class="custom-table-heading">
                            <tr>
                                <th>List of Occupants</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of details.occupants; let i = index">
                                <td>{{ item?.firstName | titlecase }}</td>
                            </tr>
                        </tbody>
                    </table>


                </div>


                <div class="details">
                    <div class="left d-flex flex-column gap-3"
                        style="border-top: 1px solid #e0e0e0; padding-top: 20px; margin-top: 20px;">
                        <h6 class="text-decoration-underline fw-bold mb-1">ENUMERATION DETAILS </h6>

                        <div><strong class="fw-bold">Date Enumerated: </strong> {{ this.details?.createdAt }}</div>
                        <div><strong class="fw-bold">Enumerated By: </strong> {{ this.details?.createdBy }}</div>

                    </div>
                </div>

            </div>


            <div class="d-flex flex-column gap-4 justify-content-start">
                <button type="submit" class="btn-yellow mx-auto flex-btn" [disabled]="!details" (click)="editAsset()">
                    Edit Asset
                    <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.0924 11.5285C9.42031 10.6473 9.47717 9.79448 9.05077 10.1925C9.05077 9.93661 9.07919 9.68077 9.10762 9.42493C9.67615 8.8564 10.131 8.03202 10.33 7.06551C10.4152 6.92338 10.529 6.80967 10.6142 6.44013C10.9554 5.33149 10.529 5.21778 10.5005 5.18935C10.5858 4.79138 10.7279 3.71116 10.529 3.1142C10.131 1.89185 7.94212 1.18118 7.45887 1.06748C6.57764 0.669503 4.6162 1.72129 4.16137 3.1142C3.96238 3.71116 4.10452 4.76295 4.1898 5.18935C3.76339 5.5589 4.04766 6.55383 4.3035 6.98023C4.10452 7.29293 3.7634 8.0036 4.10452 8.5437C4.3035 8.8564 4.70148 8.99853 5.27001 8.99853C5.38372 9.16909 5.52585 9.31122 5.66798 9.45336C5.69641 9.68077 5.69641 9.93661 5.69641 10.1925C5.58271 10.0787 5.41214 10.0787 5.29844 10.1925C5.29844 10.1925 4.50249 10.96 2.65475 11.5569C-0.159492 12.6087 0.323762 16.5316 0.465896 17.3276V17.356C0.579603 17.9814 0.636456 18.1519 0.807017 18.2372C3.7634 19.5448 11.0122 19.5448 13.9402 18.2372C14.1391 18.1519 14.196 17.9814 14.3097 17.356C14.3097 17.3276 14.3097 17.3276 14.3097 17.2991V17.3276C14.4234 16.5032 14.9351 12.6087 12.0924 11.5285ZM4.70148 3.28476C5.01417 2.37511 6.35023 1.46545 7.06089 1.55073C7.9137 1.69286 9.70458 2.46039 9.98885 3.28476C10.1026 3.65431 10.0457 4.33655 9.98885 4.79138C7.94212 4.59239 7.14617 3.22791 7.11775 3.17105C7.06089 3.08577 6.97561 3.02892 6.86191 3.02892C6.7482 3.02892 6.66292 3.08577 6.60607 3.19948C6.26495 3.88172 5.35529 4.45026 4.67305 4.79138C4.64462 4.30812 4.58777 3.65431 4.70148 3.28476ZM4.55934 8.20258C4.47406 8.08888 4.50249 7.91832 4.55934 7.74776C4.64462 7.97517 4.7299 8.17416 4.84361 8.37314C4.67305 8.31629 4.58777 8.25944 4.55934 8.20258ZM8.48223 9.90819V10.6473C7.68628 11.159 7.00404 11.1305 6.23652 10.6473C6.23652 10.3914 6.26495 10.164 6.23652 9.90819C6.97561 10.3346 7.71471 10.363 8.48223 9.90819ZM13.7412 17.1854C13.6843 17.4981 13.6559 17.6403 13.6275 17.6971C10.7848 18.891 3.96238 18.891 1.11971 17.6971C1.09128 17.6403 1.06286 17.4981 1.006 17.1854V17.157C0.892297 16.4463 0.437469 12.9498 2.82531 12.0402C4.27508 11.5569 5.12788 11.0168 5.469 10.7326C6.71977 11.8412 8.0274 11.8412 9.24975 10.7326C9.6193 11.0168 10.4437 11.5569 11.8934 12.0402C14.3097 12.9783 13.8549 16.5032 13.7412 17.1854Z"
                            fill="white" />
                    </svg>
                </button>

                <div class="image-container">


                    <img [src]="details.photo" alt="">
                </div>
            </div>


        </div>
        }
        @else {
        @if(errorLoadingDetails) {
        <div class="error-wrapper">
            <span class="text-danger">Error loading details</span>
            <div class="d-flex gap-1 align-items-center" (click)="fetchDetails()">
                <svg id='rotate_24' width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'
                    xmlns:xlink='http://www.w3.org/1999/xlink'>
                    <rect width='24' height='24' stroke='none' fill='#0d6efd' opacity='0' />


                    <g transform="matrix(1 0 0 1 12 12)">
                        <g style="">
                            <g transform="matrix(1 0 0 1 0 0)">
                                <path
                                    style="stroke: none; stroke-width: 2; stroke-dasharray: none; stroke-linecap: round; stroke-dashoffset: 0; stroke-linejoin: round; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"
                                    transform=" translate(-12, -12)" d="M 0 0 L 24 0 L 24 24 L 0 24 z"
                                    stroke-linecap="round" />
                            </g>
                            <g transform="matrix(1 0 0 1 -0.02 0.04)">
                                <path
                                    style="stroke: rgb(33,33,33); stroke-width: 2; stroke-dasharray: none; stroke-linecap: round; stroke-dashoffset: 0; stroke-linejoin: round; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;"
                                    transform=" translate(-11.98, -12.04)"
                                    d="M 19.95 11 C 19.426823372934848 7.008668052586231 16.019388752309908 4.027730919433346 11.993932303482481 4.039767370187292 C 7.968475854655056 4.051803820941237 4.578928504766239 7.053064497474491 4.079629850535927 11.04745373131699 C 3.5803311963056146 15.04184296515949 6.126812922743511 18.785107276233582 10.025446354498353 19.787654962060312 C 13.924079786253195 20.790202647887043 17.96043940517346 18.739739794677313 19.449999999999996 15.000000000000004 M 19.95 20 L 19.95 15 L 14.95 15"
                                    stroke-linecap="round" />
                            </g>
                        </g>
                    </g>
                </svg>

                <span class="text-primary" role="button">Retry</span>
            </div>
        </div>
        }
        @else {
        <app-bounce-loader></app-bounce-loader>
        }
        }
    </div>



</div>